import { getSetting } from '../../common/services/settings/settings'
const getFormSetting = getSetting('formsV2')

export const defaultState = {
  delayLoad: false,
  entryCounts: {},
  formAliases: {},
  formStates: {},
  forms: [],
  isAliasLoading: false,
  isLoading: true,
  queryParams: {
    pageSize: getFormSetting('pageSize') || 10,
    page: 1
  }
}

export default (state= defaultState, { type, data }) => {
  switch (type) {
    case 'DELAY_V2_FORMS_LOAD':
      return {
        ...state,
        delayLoad: data
      }
    case 'SET_ALIAS_LOADING':
      return { ...state, isAliasLoading: data }
    case 'SET_FORM_V2_ALIAS': {
      const { formId, formAlias } = data || {}
      if (formId) {
        return {
          ...state,
          formAliases: {
            ...state.formAliases,
            [formId]: formAlias,
          }
        }
      }
      return state
    }
    case 'SET_FORMS_V2':
      return {
        ...state,
        forms: data,
        totalCount: data?.length
      }
    case 'SET_FORMS_V2_ENTRY_COUNTS':
      return {
        ...state,
        entryCounts: data
      }
    case 'SET_FORMS_V2_LOADING':
      return {
        ...state,
        isLoading: data
      }
    case 'SET_FORMS_V2_STATES':
      return {
        ...state,
        formStates: data
      }
    default:
      return state
  }
}
